<template>
  <q-tab-pane name="danger-zone">
    <div class="danger-box round-borders q-pa-md">
      <div class="row items-center gutter-x-md">
        <div class="col-12 col-md">
          <h6 class="q-my-sm q-title">{{ $t('delete_account') }}</h6>
          <p v-html="$t('delete_account_hint')" class="q-ma-none text-faded"></p>
        </div>

        <div class="col-12 col-md-auto">
          <q-btn color="red-6" icon="warning" class="q-mt-md" @click="handleDeleteAccount">
            &nbsp;{{ $t('delete_account') }}
          </q-btn>
        </div>
      </div>
    </div>

    <authorization-dialog ref="authorizationDialog"></authorization-dialog>
  </q-tab-pane>
</template>

<script>
  import AuthorizationDialog from 'components/Common/AuthorizationDialog.vue'
  import { UserClient } from 'src/api/Users'
  import { createErrorFromResponse } from 'src/utils/error'
  import { mapActions } from 'vuex'

  export default {
    methods: {
      ...mapActions(['logout']),

      handleDeleteAccount () {
        this.$refs.authorizationDialog.open()
          .then(authorizationPassword => {
            this.deleteUser(authorizationPassword)
          })
      },

      deleteUser (authorizationPassword) {
        new UserClient()
          .delete(authorizationPassword)
          .then(() => {
            this.$q.notify({ message: this.$t('account_deleted'), timeout: 5000, type: 'positive' })
          })
          .catch(createErrorFromResponse)
      }
    },

    components: {
      AuthorizationDialog
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .danger-box
    border: 1px solid $red-3
</style>
